<template>
  <div class="login-wrapper">
    <div class="middle-box text-center">
      <div>
        <img width="80%" src="../../../public/img/sgo-logo-slogan-azul.png" alt="logo">
      </div>


      <form @submit.prevent="login" id="form-principal" class="m-t" role="form">
        <div class="form-group text-left mb-4">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-at"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <InputText id="email" type="email" v-model="email" size="small" style="width: 100%"
                         autocomplete="username"
                         :invalid="campoVazio.includes('email')" autofocus/>
              <label for="email"><strong>E-mail: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>
        <div class="form-group text-left mb-4">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-lock"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <Password inputId="password" v-model="password" :feedback="false" toggleMask size="small"
                        fluid style="width: 100%"
                        :inputProps="{ autocomplete: 'current-password' }"
                        :invalid="campoVazio.includes('password')"/>
              <label for="password"><strong>Senha: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>
        <div class="form-group text-center mb-4 d-flex justify-content-center">
          <Recaptcha ref="recaptcha" :siteKey="turnstileSiteKey" @verify="onCaptchaVerify" />
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary full-width m-b w-100 font-bold p-2">Entrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {apiUrl} from "@/router/apiBackRoutes";
import Recaptcha from "@/components/Recaptcha.vue";

export default {
  name: "LoginView",
  components: {
    Recaptcha
  },
  data() {
    return {
      email: "",
      password: "",
      campoVazio: [],
      turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
      turnstileToken: null,
    }
  },
  methods: {
    onCaptchaVerify(token) {
      this.turnstileToken = token;
    },
    resetCaptcha() {
      this.turnstileToken = null;
      if (this.$refs.recaptcha && typeof this.$refs.recaptcha.reset === "function") {
        this.$refs.recaptcha.reset();
      }
    },
    async login() {
      if (!this.turnstileToken) {
        this.$toastMessage("warn", "Atenção", "Por favor, resolva a verificação de segurança antes de entrar.");
        return;
      }
      try {
        const response = await fetch(apiUrl.usuarios.login, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            email: this.email,
            password: this.password,
            "cf-turnstile-response": this.turnstileToken,
          }),
        });
        const data = await response.json();
        if (response.ok) {
          localStorage.setItem('admin_isAuthenticated', true);
          await this.usuarioLogado();
          this.$router.push('/');
          this.$toastMessage("success", "Login realizado com sucesso!");
        } else {
          this.$toastMessage("error", data.detail || "Erro ao realizar login");
          this.campoVazio = data && typeof data === 'object' ? Object.keys(data) : [];
          this.resetCaptcha();
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        this.resetCaptcha();
      }
    },
    async usuarioLogado() {
      const response = await fetch(apiUrl.usuarios.usuarioLogado, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('admin_username', data.username);
        localStorage.setItem('admin_userID', data.user_id);
        localStorage.setItem('admin_primeiroAcesso', data.primeiro_acesso);
        if (data.user_foto) {
          localStorage.setItem('admin_userFoto', data.user_foto);
        }
        localStorage.setItem('admin_firstName', data.first_name);
        localStorage.setItem('admin_lastName', data.last_name);
        localStorage.setItem('admin_email', data.email);
        localStorage.setItem('admin_isActive', data.is_active);
        localStorage.setItem('admin_isStaff', data.is_staff);
        localStorage.setItem('admin_isSuperUser', data.is_superuser);
        localStorage.setItem('admin_lastLogin', data.last_login);
      }
    }
  },
}
</script>

<style scoped>
.login-wrapper {
  background-image: url('../../../public/img/sgo-azul-fundo.jpg');
  background-size: cover;
  background-position: center;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

.middle-box {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 30px;
  border-radius: 50px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  width: 350px;
}

:deep(.p-password) {
  width: 100%;
}

:deep(.p-password-input) {
  width: 100%;
  box-sizing: border-box;
}

:deep(.p-password-mask),
:deep(.p-password-toggle-mask),
:deep(.p-password-toggle-mask-icon) {
  z-index: 99 !important;
  color: #333 !important;
}
</style>
